<template>
  <div class="content">
    <h1>Edycja dokumentu magazynowego</h1>
    <app-loading :active="loading"></app-loading>
    <form action="#" @submit.prevent="submit" style="width:100%" class="flex">
      <AppWarehouseDocForm @input="getFormData" ref="form" class="box--wide"></AppWarehouseDocForm>
      <button class="btn btn--margined btn--gradient" type="submit">Zapisz</button>
    </form>
  </div>
</template>

<script>
import WarehouseDocForm from '@/components/WarehouseDocForm.vue'
import Loading from '@/components/Loading.vue'

import { api } from '../api'

export default {
  name: 'add-warehouse-doc-view',
  data() {
    return {
      form: {},
      loading: false
    }
  },
  methods: {
    async loadCurrent() {
      const resp = await api.get(`/docs/${this.$route.params.id}`)
      this.current = resp.data
      this.form = {...this.current}
      this.$refs.form.setData(this.current)
    },
    async submit() {
      this.loading = true

      const { id, error } = await this.$store.dispatch('docs/editDoc', {
        id: this.$route.params.id,
        doc: this.form
      })
      console.log('TCL: submit -> id', id)

      if(id) {
        this.$router.push(`/doc/${id}`)
      }

      if(error) {
        this.$vs.notify({
          title: 'Błąd w zapisie',
          text: error.data.message,
          color: 'danger',
          icon: 'error'
        })
      }

      this.loading = false
    },
    getFormData(data) {
      this.form = data
    }
  },
  components: {
    AppWarehouseDocForm : WarehouseDocForm,
    AppLoading: Loading
  },
  mounted() {
    this.loadCurrent()
  },
  metaInfo: {
    title: 'Edytuj dokument magazynowy'
  }
}
</script>

<style lang="scss" scoped>
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

</style>

